import { useConfig } from '@root/Context'

const useIsDoctor = (): boolean => {
  const { isDoctor } = useConfig()
  return !!isDoctor
}

export default useIsDoctor
